export const SCANYE_DOCUMENT_STATUS_SUCCESS = 'SUCCESS';
export const SCANYE_DOCUMENT_STATUS_PENDING = 'PENDING';
export const SCANYE_DOCUMENT_STATUS_RUNNING = 'RUNNING';
export const SCANYE_DOCUMENT_STATUS_PARTIAL = 'PARTIAL';
export const SCANYE_DOCUMENT_STATUS_ERROR = 'ERROR';
export const SCANYE_DOCUMENT_STATUS_BEFORE_OCR = 'BEFORE_OCR';

export const SCANYE_STATUS_REFRESH_RATE = 2000;
